import dynamic from 'next/dynamic';

const FleetVehiclesGrid = dynamic(() =>
  import('./FleetVehiclesGrid/FleetVehiclesGrid')
);
const FleetVehicleMenu = dynamic(() =>
  import('./FleetVehicleMenu/FleetVehicleMenu')
);
const VehicleProcurement = dynamic(() =>
  import('./VehicleProcurement/VehicleProcurement')
);

const AddVehiclePlate = dynamic(() =>
  import('./AddVehiclePlate/AddVehiclePlate')
);

const AddVehicleMileage = dynamic(() =>
  import('./AddVehicleMileage/AddVehicleMileage')
);
const ConfigureServicePointModal = dynamic(() =>
  import('./ConfigureServicePointModal/ConfigureServicePointModal')
);
const VehicleServicePoints = dynamic(() =>
  import('./VehicleServicePoints/VehicleServicePoints')
);
const VehicleDocuments = dynamic(() =>
  import('./VehicleDocuments/VehicleDocuments')
);
const AddVehicleDocument = dynamic(() =>
  import('./AddVehicleDocument/AddVehicleDocument')
);
const CancelVehicleModal = dynamic(() =>
  import('./CancelVehicleModal/CancelVehicleModal')
);
const DefleetVehicleModal = dynamic(() =>
  import('./DefleetVehicleModal/DefleetVehicleModal')
);
const FleetVehiclesFilters = dynamic(() =>
  import('./FleetVehiclesFilters/FleetVehiclesFilters')
);
const VehiclePage = dynamic(() => import('./VehiclePage/VehiclePage'));
const AddVehicleForm = dynamic(() => import('./AddVehicleForm/AddVehicleForm'));
const FleetVehiceOverview = dynamic(() =>
  import('./FleetVehiceOverview/FleetVehiceOverview')
);
const FleetVehicleHeader = dynamic(() =>
  import('./FleetVehicleHeader/FleetVehicleHeader')
);

const VehicleInvoiceInfo = dynamic(() =>
  import('./VehicleInvoiceInfo/VehicleInvoiceInfo')
);

const FleetVehiclePricing = dynamic(() =>
  import('./FleetVehiclePricing/FleetVehiclePricing')
);
const AddFleetVehicleButton = dynamic(() =>
  import('./AddFleetVehicleButton/AddFleetVehicleButton')
);
const FleetVehicleExportMenu = dynamic(() =>
  import('./FleetVehicleExportMenu/FleetVehicleExportMenu')
);
const FleetVehicleDetailsModal = dynamic(() =>
  import('./FleetVehicleDetailsModal/FleetVehicleDetailsModal')
);

export {
  FleetVehiclesGrid,
  FleetVehicleMenu,
  VehicleProcurement,
  AddVehiclePlate,
  AddVehicleMileage,
  ConfigureServicePointModal,
  VehicleServicePoints,
  VehicleDocuments,
  AddVehicleDocument,
  CancelVehicleModal,
  DefleetVehicleModal,
  FleetVehiclesFilters,
  VehiclePage,
  AddVehicleForm,
  FleetVehiceOverview,
  FleetVehicleHeader,
  VehicleInvoiceInfo,
  FleetVehiclePricing,
  AddFleetVehicleButton,
  FleetVehicleExportMenu,
  FleetVehicleDetailsModal,
};
